import React from 'react';
import TableHeadContext from './TableHeadContext';

export default function useTableHead() {
  return React.useContext(TableHeadContext);
}
